import React, {useState, useEffect} from "react";
import { PolarArea } from "react-chartjs-2";
import { useMediaQuery } from '@mui/material';
import { Chart, RadialLinearScale, ArcElement, Tooltip, Legend } from "chart.js";

// Register components for Polar Area Chart
Chart.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export default function ReportCardChartPolar({argData}) {
  const isMobile = useMediaQuery('(max-width:600px)'); // Detect small screens

  const data = {
    labels: [
      ["Relevance","& Logic"], 
      "Development", 
      "Grammar", 
      "Spelling", 
      "Vocabulary", 
      ["Structure","& Flow"]],
    datasets: [
      {
        label: "Score",
        data: [],
        backgroundColor: [
          'rgba(139, 195, 74, 0.7)',  // Leaf Green
          'rgba(29, 53, 87, 0.85)', // Midnight Canopy
          'rgba(121, 85, 72, 0.7)',   // Tree Brown
          'rgba(0, 188, 212, 0.7)',   // Sky Blue
          'rgba(255, 152, 0, 0.7)',   // Tiger Orange
          'rgba(0, 150, 136, 0.7)'    // Teal Water
        ],
        borderWidth: 1,
      },
    ],
  };
  const [chartData, setChartData] = useState(data);
  useEffect(()=>{
    if(!argData) return;
    var _chartData = {...chartData};
    _chartData.datasets[0].data = argData.map(r=>r.score);
    setChartData(_chartData);
  }, [argData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      // Extra padding on small screens so labels aren't clipped
      padding: isMobile ? 24 : 12,
    },

    plugins: {
      legend: { display:false, position: "bottom" },
      tooltip: { 
        enabled: true, 
        bodyFont: {
          size: 16
        }, 
        titleFont: { 
          size: 18
        }, 
      },
      datalabels: { display: false, },
    },
    scales: {
      r: {
        ticks: { display:false },
        pointLabels: {
          display: true,
          centerPointLabels: true,
          font: {
            size: isMobile ? 14 : 15, 
            weight: 'bold', 
          }, 
          color: '#000000'
        }
      }
    },
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: isMobile ? 260 : 320,  // tweak these numbers if needed
      }}
    >
      <PolarArea
        data={chartData}
        options={options}
        key={JSON.stringify(chartData)}
      />
    </div>
  );
}